import { create } from 'zustand';
import { devtools, subscribeWithSelector } from 'zustand/middleware';

import type { StateCreator } from 'zustand';
import type { ServiceMetaRoute } from '../constants';

export enum RemoteRouteStatus {
  Idle = 'idle',
  RouteLoading = 'route-loading',
  ModuleLoading = 'module-loading',
}

export interface RemoteRouteState {
  route: ServiceMetaRoute | null;
  status: RemoteRouteStatus;
}

export interface RemoteRouteAction {
  setRoute: (route: ServiceMetaRoute) => void;
  setStatus: (status: RemoteRouteStatus) => void;
}

export type RemoteRouteStore = RemoteRouteState & RemoteRouteAction;

const initialState: RemoteRouteState = {
  status: RemoteRouteStatus.Idle,
  route: null,
};

const createRemoteRouteSlice: StateCreator<
  RemoteRouteStore,
  [['zustand/devtools', never]],
  []
> = set => ({
  ...initialState,
  setStatus: status => {
    return set({ status });
  },
  setRoute: route => {
    return set({ route });
  },
});

export const useRemoteRouteStore = create<RemoteRouteStore>()(
  subscribeWithSelector(
    devtools(
      (...args) => ({
        ...createRemoteRouteSlice(...args),
      }),
      {
        name: 'RemoteRouteStore',
      },
    ),
  ),
);
